import { useListboxContext, ListboxOption } from '@reach/listbox';
import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../../../react/components/core/render-with-ref.js';
import { useLegacyListboxInternalContext } from './legacy.listbox.context.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.string.isRequired,
    labelNode: PropTypes.node,
    label: PropTypes.string
};
/**
 * @deprecated Use new Listbox and its sub-components instead
 */ const LegacyListboxOption = renderWithRef('LegacyListboxOption', propTypes, (props, ref)=>{
    const { as , component , value , labelNode , className  } = props, otherProps = _object_without_properties(props, [
        "as",
        "component",
        "value",
        "labelNode",
        "className"
    ]);
    const { setLabelMap  } = useLegacyListboxInternalContext();
    const { value: selectedValue  } = useListboxContext();
    const classes = new Set([
        'swan-legacy-listbox-option'
    ]);
    // console.log(classes)
    if (className) classes.add(className);
    const processedClassName = Array.from(processStyleProps(props, classes)).join(' ');
    React.useEffect(()=>{
        setLabelMap((u)=>_object_spread_props(_object_spread({}, u || {}), {
                [value]: labelNode
            }));
    }, [
        labelNode,
        setLabelMap,
        value
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ React.createElement(ListboxOption, _object_spread_props(_object_spread({
        as: as || component,
        value: value,
        ref: ref,
        className: processedClassName
    }, otherProps), {
        "aria-selected": String(value === selectedValue)
    }));
});

export { LegacyListboxOption };
